import React, { useState } from "react";
import {
  Card,
  CardBody,
  Button,
  UncontrolledTooltip
} from "reactstrap";
import { ChevronDown, ChevronRight } from "react-feather";
import { useTranslation } from "context/TranslationProvider";
import helpers from "utils/helpers";

const PlaceholderSidebar = ({ placeholders, onInsert, rightCardHeight }) => {
  const { t } = useTranslation();
  const [openSections, setOpenSections] = useState({});

  const toggleSection = (section) => {
    setOpenSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const collapseAllSections = () => {
    setOpenSections({});
  };

  return (
    <Card
      className="shadow placeholder-card"
      style={rightCardHeight ? { "--right-card-height": `${rightCardHeight}px` } : undefined}
    >
      <div className="d-flex justify-content-between align-items-center p-3 border-bottom">
        <h4 className="mb-0">
          {t("page.notificationTemplates.placeholders", "Placeholders")}
        </h4>

        <Button
          id="collapse-all-sections"
          size="sm"
          className="p-2 d-flex align-items-center"
          onClick={collapseAllSections}
        >
          <ChevronDown size={16} />
        </Button>

        <UncontrolledTooltip target="collapse-all-sections">
          {t("page.notificationTemplates.buttons.collapseAll", "Collapse All")}
        </UncontrolledTooltip>
      </div>

      <CardBody className="placeholder-body">
        {!placeholders || Object.keys(placeholders).length === 0 ? (
          <p className="text-muted">
            {t("page.notificationTemplates.loading", "Loading Placeholders....")}
          </p>
        ) : (
          Object.entries(placeholders).map(([section, fields]) => {
            const isOpen = openSections[section];

            return (
              <div key={section} className="mb-3">

                <button
                  type="button"
                  onClick={() => toggleSection(section)}
                  className="section-header d-flex align-items-center justify-content-between py-2 px-3 border rounded w-100 form-control-label"
                >
                  <span className="font-weight-bold">
                    {helpers.formatLabel(section, t)}
                  </span>

                  {isOpen ? (
                    <ChevronDown size={16} />
                  ) : (
                    <ChevronRight size={16} />
                  )}
                </button>

                {isOpen && (
                  <div className="mt-2 placeholder-children">
                    {Object.entries(fields).map(([key, value]) => (
                      <button
                        key={key}
                        type="button"
                        onClick={() => onInsert(`{{${value}}}`)}
                        className="placeholder-item py-2 px-3 border rounded mb-2 w-100 text-left form-control-label"
                      >
                        {helpers.formatLabel(key, t)}
                      </button>
                    ))}
                  </div>
                )}

              </div>
            );
          })
        )}
      </CardBody>
    </Card>
  );
};

export default PlaceholderSidebar;